module.exports = __webpack_public_path__ + "img/builder-22.30f03f72.webp";